<template>
  <div
    class="card__form-item"
    :class="{
      'card__form-item--animate':
        (typeof dataState === 'string' &&
          dataState &&
          dataState.trim() !== '') ||
        selectSearching ||
        type === 'date' || (type === 'day' && inputValue || (type === 'number' && dataState)),
      'card__form-item--error': error || manualError,
      'card__form-item--shake': rejectedInput,
      'mb-4': type === 'countries' || type === 'multiselect',
      'mb-0': noMargin,
      'mb-4': !noMargin,
      'overflow-hidden cursor-pointer': type === 'checkbox' && noBoxes,
      'z-60': forceTop
    }"
    :noFocus="noFocus"
    @click="
      () => (type === 'checkbox' && noBoxes ? (dataState = !dataState) : '')
    "
  >
    <!-- COUNTRIES -->
    <Field
      v-if="type === 'countries'"
      v-model="dataState"
      :rules="rules"
      :name="name" v-slot="{ field }"
      >
      <multiselect
        v-bind="field"
        v-model="dataState"
        class="card__card-input card__card-input--multiselect"
        :options="getCountries()"
        :groups="false"
        :searchable="true"
        :multiple="false"
        :canClear="false"
        :disabled="locked"
        :autocomplete="'off'"
        @open="changeSelect(true, field.name)"
        @close="changeSelect(false)"
        label="country"
        trackBy="country"
        :caret="caret"
        valueProp="key"
        :style="
          dataState
            ? 'justify-content: space-between; height: 4rem;'
            : 'padding-bottom: 1.9rem !important;'
        "
        :classes="{
          singleLabel: locked
            ? 'relative card-input--disabled '
            : 'relative card-input',
          dropdown:
            'min-h-72 max-h-80 pointer-events-all pretty-scroll overflow-y-scroll absolute -left-px -right-px -bottom-1 transform translate-y-full bg-white flex flex-col rounded-2xl shadow-dropdown z-70',
          dropdownTop:
            '-translate-y-full top-px bottom-auto rounded-b-none rounded-t',
          dropdownHidden: 'hidden',
          groupLabel:
            'flex text-sm box-border items-center justify-start text-left py-1 px-3 font-semibold cursor-default leading-normal ',
          groupOptions: 'p-0 m-0 border-b-2 border-grey-8',
          optionSelected: 'text-grey-2 font-semibold',
          option:
            'flex text-grey-3 pointer-events-all items-center justify-start box-border text-left cursor-pointer text-sm font-normal leading-snug py-3 px-4',
          optionPointed: 'bg-grey-8',
          optionDisabled: 'opacity-50 cursor-not-allowed',
          optionSelectedPointed: 'font-semibold bg-grey-8',
          search:
            'multiselect-search w-full absolute inset-0 outline-none focus:ring-0 appearance-none box-border border-0 text-base font-sans bg-white rounded pl-3.5 rtl:pl-0 rtl:pr-3.5'
        }"
        :name="name"
      >
        <template v-slot:option="option">
          <div
            class="w-6 h-6 bg-cover bg-center rounded-lg mr-2"
            :style="
              'background-image: url(\'' +
              `/img/flags/${option.option.key.toLowerCase()}.png` +
              '\')'
            "
          ></div>
          {{ option.option.country }}</template
        >
      </multiselect>
    </Field>   
    <!-- PHONE -->
    <div v-else-if="type === 'phone'" :class="((error || manualError) ? 'mb-8 ' : '') + 'flex'">
      <multiselect
        v-model="phoneCodeState"
        ref="phoneCodeRef"
        class="
          card__card-input card__card-input--phone-code
          pointer-events-none
        "
        :class="locked ? 'card__card-input--phone-code--disabled ' : ''"
        :options="getCountriesCell()"
        :style="'background: transparent'"
        :searchable="true"
        :multiple="false"
        :canClear="false"
        :disabled="locked"
        :autocomplete="'off'"
        label="code"
        inputType="numeric"
        trackBy="code"
        valueProp="code"
        :closeOnSelect="true"
        :clearOnSelect="false"
        :classes="{
          singleLabel: 'relative text-grey-2 font-semibold	',
          dropdown:
            'min-h-72 max-h-80 pointer-events-all pretty-scroll overflow-y-scroll absolute -left-px -right-px -bottom-1 transform translate-y-full z-50 bg-white flex flex-col rounded-2xl shadow-dropdown',
          dropdownTop:
            '-translate-y-full top-px bottom-auto rounded-b-none rounded-t',
          dropdownHidden: 'hidden',
          optionSelected: 'text-grey-2 font-semibold',
          option:
            'flex text-grey-3 pointer-events-all items-center justify-start box-border text-left cursor-pointer text-sm font-normal leading-snug py-3 px-4',
          optionPointed: 'bg-grey-8',
          optionSelectedPointed: 'font-semibold bg-grey-8',
          search:
            'no-error-input w-full absolute inset-0 outline-none focus:ring-0 appearance-none box-border border-0 text-base font-sans h-full rounded pl-3.5 rtl:pl-0 rtl:pr-3.5 ' + bgColor
        }"
        @search-change="maskPhoneCode"
        :name="name + '-phone'"
        ><template v-slot:option="option" class="pointer-events-all">
          <div
            :style="
              'background-image: url(\'' +
              `/img/flags/${option.option.iso.toLowerCase()}.png` +
              '\')'
            "
            class="
              w-6
              h-6
              mr-2
              bg-center bg-cover
              rounded-lg
              pointer-events-all
            "
          ></div>
          <div class="pointer-events-all"></div>
          <span class="text-grey-2 font-semibold pointer-events-all">{{
            '+ ' + option.option.code
          }}</span>
          <span
            class="
              text-grey-2
              font-regular
              text-opacity-80
              ml-1
              pointer-events-all
            "
            >{{ option.option.country }}</span
          >
        </template>
        <template v-slot:singlelabel="value"
          ><div class="multiselect-single-label" style="top: -7px !important">
            {{ '+ ' + value.value.code }}
          </div></template
        >
      </multiselect>
      <Field
        :class="
          (locked
            ? 'card__card-input--disabled card__card-input--phone--disabled z-40 '
            : 'card__card-input card__card-input--phone z-40 ') + bgColor
        "
        ref="field"
        v-model="dataState"
        :type="'number'"
        :name="name"
        :min="min"
        :max="max"
        :disabled="locked"
        @focus="changeSelect(true)"
        @blur="changeSelect(false)"
        :minLength="minLength"
        :maxLength="maxLength"
        :exactLength="exactLength"
        :rules="rules"
        style="
          padding-left: 24px;
          border-top-left-radius: 0px !important;
          border-bottom-left-radius: 0px !important;
          margin-left: 120px;
        "
      />
    </div>
    <!-- MULTISELECT -->
    <multiselect
      v-model="dataState"
      v-else-if="type === 'multiselect'"
      class="card__card-input card__card-input--multiselect"
      :options="options"
      :searchable="searchable"
      :multiple="multiple"
      autocomplete='off'
      :canClear="false"
      :canDeselect="false"
      :closeOnSelect="true"
      @open="changeSelect(true)"
      @close="changeSelect(false)"
      :label="multiselectLabel"
      :trackBy="multiselectTrackBy"
      :valueProp="multiselectValueProp"
      :name="name"
      :disabled="locked"
      :style="
        dataState
          ? 'background:' +
            styleBgColor +
            '; justify-content: space-between;  min-heigth: 61px'
          : 'background:' + styleBgColor + '; min-heigth: 61px'
      "
      :classes="{
        singleLabel: locked
          ? 'relative card-input--disabled '
          : 'relative card-input',
        dropdown:
          'max-h-80 pointer-events-all pretty-scroll overflow-y-auto absolute -left-px -right-px -bottom-1 transform translate-y-full z-60 bg-white flex flex-col rounded-2xl shadow-dropdown',
        dropdownTop:
          '-translate-y-full top-px bottom-auto rounded-b-none rounded-t',
        dropdownHidden: 'hidden',
        options: 'flex flex-col p-0 m-0 list-none z-70',
        optionSelected: 'text-grey-2 font-semibold',
        option:
          'flex text-grey-3 pointer-events-all items-center justify-start box-border text-left cursor-pointer text-sm font-normal leading-snug py-3 px-4',
        optionPointed: 'bg-grey-8',
        optionSelectedPointed: 'font-semibold bg-grey-8',
        search:
          'multiselect-search no-error-input w-full absolute inset-0 outline-none focus:ring-0 appearance-none box-border border-0 text-base font-sans bg-white rounded pl-3.5 rtl:pl-0 rtl:pr-3.5'
      }"
    >
    </multiselect>
    <!-- CHECKBOXES -->
    <div v-else-if="type === 'checkbox'" class="flex">
      <!--div
        v-if="!noBoxes && greenBg"
        class="
          h-40
          bg-green-5
          absolute
          left-1
          -top-5
          z-20
          rounded-lg
          transform
          -rotate-12
          transition-all
          origin-left
          duration-500
          rounded-5xl
        "
        :class="dataState ? 'w-full pr-32' : 'w-0'"
      /-->
      <div
        v-if="!noBoxes"
        class="my-auto relative z-50 mr-2"
        :class="{ 'cursor-pointer': !noBoxes }"
        @click="
          () => {
            if (!noBoxes) dataState = !dataState
          }
        "
      >
        <div
          class="w-6 h-6 rounded-lg transition duration-75 relative"
          :class="!dataState ? 'bg-grey-6' : 'bg-green-3'"
        >
          <div
            class="
              absolute
              left-1/2
              top-1/2
              transform
              -translate-x-1/2 -translate-y-1/2
            "
            v-if="dataState"
          >
            <img src="@/assets/svg/check_white.svg" alt="" class="w-3" />
          </div>
        </div>
      </div>
      <div
        class="
          text-grey-3 text-sm text-left
          flex-grow
          col-span-11
          relative
          mr-2
          overflow-hidden
          transition-all
        "
        :class="{
          'selected text-opacity-100': bold && dataState,
          'bg-grey-ghost hover:bg-green-5 hover:shadow-lg p-2 rounded-lg mb-4': noBoxes
        }"
        style="min-width: 36px"
      >
        <div
          v-if="noBoxes"
          class="
            h-40
            bg-green-5
            absolute
            left-0
            top-0
            z-20
            rounded-lg
            transform
            -rotate-45
            transition-all
            origin-left
            duration-700
            rounded-5xl
          "
          :class="dataState ? 'w-full pr-24' : 'w-0'"
        ></div>
        <div class="relative z-50 no-highlight">
          <slot name="label">
            <div v-html="label" @click="() => {if(!noBoxes) dataState = !dataState}"/>
          </slot>
        </div>
      </div>
    </div>
    <div v-else-if="type === 'sdgs'" class="grid md:grid-cols-6 grid-cols-3 gap-6 md:gap-3">
      <div v-for="(goal, index) in goals" class="relative"
        @click.prevent="onGoalClick(goal)"
        @mouseover="goalHover = goal"
        @mouseleave="goalHover = null"
        v-bind:key="goal">
          <input type="checkbox" :value="goal" :id="goal" v-model="dataState" class="hidden" :disabled="dataState && dataState.length > 2 && !dataState.includes(goal)">
          <label :for="goal">
            <img
            style="-webkit-user-drag: none;"
            :src="getSdgSrc(goalHover, goal)"
            alt="sdg goal"
            class="cursor-pointer w-full transition-all"
            :class="{'opacity-40 cursor-not-allowed': dataState && dataState.length > 2 && !dataState.includes(goal)}"

          />
          </label>
          <div 
            v-if="goalHover === goal && ((dataState && dataState.length < 3) || dataState.includes(goal)) && !isMobile"
            @mouseover="goalHover = goal"
            @click.stop
            class="bg-white py-4 px-6 rounded-2xl absolute -bottom-24 z-20 w-56" 
            :class="[5,6,11,12,17].includes(index + 1) ? 'right-14': 'left-14'" 
            style="box-shadow: 4px 4px 20px 0px rgba(179, 218, 187, 0.30);">
              <div class="font-bold text-grey-2 mb-2" style="">{{$t('wording.goal')}} {{ index + 1 }}</div>
              <div class="text-sm text-grey-3 mb-2">{{$t('sdgs.' + (index + 1))}}</div>
              <div style="pointer-events: all;">
                <a class="orange-link" :href="'https://sdgs.un.org/goals/goal'+(index + 1)" target="_blank">
                  {{$t('wording.learn_more')}}
                </a>
              </div>
          </div>
      </div>
    </div>
    <!-- CHECKBOX GROUP -->
    <div v-else-if="type === 'checkbox-group'">
      <template v-if="dataState">
        <div v-for="(option, key, index) in options" v-bind:key="option"
             class="
                flex
                bg-white
                p-4
                cursor-pointer
              "
             :class="{
              'rounded-b-3xl' : index == Object.keys(options).length - 1,
              'rounded-t-3xl' : index == 0,
              'border-b border-grey-7': index !== Object.keys(option).length - 1,
              'opacity-40 cursor-not-allowed': dataState['none'] && key !== 'none'
             }"
             @click="toggleDataState(dataState, key)"
        >
          <div
            v-if="!noBoxes"
            class="my-auto relative z-50 mr-2"
            :class="{ 'cursor-pointer': !noBoxes }"

          >
            <div
              class="w-6 h-6 rounded-lg transition duration-75 relative"
              :class="!dataState[key] ? 'bg-grey-6' : 'bg-green-3'"
            >
              <div
                class="
                  absolute
                  left-1/2
                  top-1/2
                  transform
                  -translate-x-1/2 -translate-y-1/2
                "
                v-if="dataState[key]"
              >
                <img src="@/assets/svg/check_white.svg" alt="" class="w-3" />
              </div>
            </div>
          </div>
          <div
            class="
              text-grey-3 text-sm text-left
              flex-grow
              col-span-11
              relative
              mr-2
              overflow-hidden
              transition-all
            "
            :class="{
              'selected text-opacity-100': dataState[key],
            }"
            style="min-width: 36px"
          >
            <div
              v-if="noBoxes"
              class="
                h-40
                bg-green-5
                absolute
                left-0
                top-0
                z-20
                rounded-lg
                transform
                -rotate-45
                transition-all
                origin-left
                duration-700
                rounded-5xl
              "
              :class="dataState[key] ? 'w-full pr-24' : 'w-0'"
            ></div>
            <div class="relative z-50 no-highlight">
              <slot name="label">
                <div v-html="option" />
              </slot>
            </div>
          </div>
      </div>
      </template>
    </div>
    <!-- TOGGLE SWITCH -->
    <div
      class="
        relative
        inline-block
        w-10
        mr-2
        align-middle
        select-none
        transition
        duration-100
        ease-in
      "
      v-else-if="type === 'toggle'"
    >
      <input
        type="checkbox"
        name="toggle"
        v-model="dataState"
        :id="name"
        class="
          card__card-input__toggle
          absolute
          block
          w-5
          h-5
          top-0.5
          left-0.5
          rounded-full
          bg-white
          appearance-none
          cursor-pointer
          transition
          duration-100
          ease-in
        "
      />
      <label
        :for="name"
        class="
          toggle-label
          block
          overflow-hidden
          h-6
          rounded-full
          bg-gray-300
          cursor-pointer
        "
      ></label>
    </div>
    <!-- RADIO -->
    <div
      v-else-if="type === 'radio'"
      :class="{
        'rounded-2xl bg-white overflow-hidden': !separatedRadio,
        'grid grid-cols-2 lg:grid-cols-3 gap-4': grided
      }"
    >
    <div
    v-for="(label, value, index) of options"
        :key="value">
      <div

        class="relative overflow-hidden transition-all transform"
        :class="[
          bgColor,
          {
            'green-shadow': dataState == value && separatedRadio,
            'rounded-2xl mb-3': separatedRadio,
            'hover:shadow-md hover:-translate-y-1': dataState !== value
          }
        ]"
      >
        <button
          :disabled="locked"
          class="flex flex-col w-full"
          :class="{ 'cursor-not-allowed': locked }"
          name="radio-input"
          @click="
            () => {
              if (!locked) dataState = value
              radioButtonPressed(dataState)
            }
          "
          @blur="blured"
        >
          <!-- <div
            class="
              h-96
              bg-green-5
              absolute
              left-6
              -top-5
              z-20
              rounded-lg
              transform
              -rotate-12
              transition-all
              origin-left
              duration-500
              rounded-5xl
            "
            :class="dataState === value ? 'w-full pr-60' : 'w-0'"
            v-if="radioGreenBg"
          ></div> -->

          <div
            class="flex w-full px-4 my-4 z-50"
            :class="{ 'cursor-not-allowed': locked, 'flex-row-reverse justify-end': !images, 'items-center justify-between': images }"
          >
            <div class="flex">
              <div v-if="images" class="bg-grey-7 w-12 h-12 rounded-2xl mr-4 relative flex-shrink-0">
                <img :src="require('@/assets/svg/' + images + '/' + (index + 1) + '.svg')" alt="" class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 transform">  
              </div>
              <div>
                <p
                    class="text-left transition-all"
                    :class="{'font-bold text-grey-2': (typeof label === 'object')}"
                  >
                  <slot name="label" v-if="(typeof label === 'object')">
                    <div class="md:mr-0  mr-4 mb-3 md:mb-0">{{ label.title }}</div>
                    <div class="text-sm text-grey-3 font-normal mr-4">{{ label.subtitle }}</div>
                  </slot>
                  <slot name="label" v-else>{{ label }}</slot>
                </p>
              </div>
            </div>
            <div
              v-if="dataState === value && !noBoxes"
              class="
                mr-4
                rounded-full
                bg-green-9
                w-4
                h-4
                flex
                items-center
                justify-center
              "
              :class="{'mt-1': !images}"
              style="flex-shrink: 0"
            >
              <div class="rounded-full bg-white w-2 h-2" />
            </div>
            <img
              v-else-if="!separatedRadio && !noBoxes"
              src="@/assets/svg/radio_off.svg"
              alt=""
              class="mr-2 mt-px"
              style="flex-shrink: 0"
            />
            <div
              v-else-if="!noBoxes"
              class="mr-4 rounded-full bg-grey-5 w-4 h-4 mt-1"
              style="flex-shrink: 0"
            />


          </div>
          <div
            v-if="
              !separatedRadio &&
              index + 1 !== Object.keys(options).length &&
              !noLines
            "
            class="w-full h-px bg-grey-7"
          >
          </div>
        </button>
      </div>
      <div class="text-grey-3 text-xs ml-4 mb-4" v-if="(typeof label === 'object') && label.caption">
        {{ label.caption }}
      </div>
    </div>
    </div>
    
    <!-- DROPDOWN -->
    <div v-else-if="type === 'dropdown'">
      <div
        class="
          w-full
          flex
          justify-between
          items-center
          bg-white
          rounded-2xl
          cursor-pointer
          p-4
          mb-1
        "
        @click="() => (dropdown = !dropdown)"
      >
        <p
          class="text-grey-2"
          :class="
            dropdown || selected
              ? 'font-bold text-opacity-80 text-sm'
              : 'text-13 text-opacity-50'
          "
        >
          {{ label }}
        </p>
        <img
          v-if="dropdown"
          src="@/assets/svg/arrows/down_grey_arrow.svg"
          alt="down"
          class="w-4 h-4 transform rotate-180"
        />
        <img
          v-else
          src="@/assets/svg/arrows/down_grey_arrow.svg"
          alt="down"
          class="w-4 h-4"
        />
      </div>
      <div v-if="dropdown && multiSelect" class="relative">
        <div class="absolute bg-white rounded-2xl py-4 z-40 w-full shadow-xl">
          <div
            class="flex items-center mb-6 px-4"
            v-for="(data, key) of dataState"
            :key="key"
          >
            <img
              v-if="!dataState[key]"
              class="cursor-pointer"
              src="@/assets/svg/checkbox_off.svg"
              alt="checkbox off"
              @click="() => (dataState[key] = true)"
            />
            <img
              v-else
              class="cursor-pointer"
              src="@/assets/svg/checkbox_on.svg"
              alt="checkbox on"
              @click="() => (dataState[key] = false)"
            />
            <p
              class="text-grey-2 text-sm text-opacity-60 text-left ml-2"
              :class="
                bold && dataState[key] ? 'font-bold text-opacity-100' : ''
              "
            >
              {{ optionsLabels[key] }}
            </p>
          </div>
          <div class="w-full bg-grey-2 bg-opacity-10 h-px" />
          <div
            class="mt-4 orange-link text-xs text-right px-4 cursor-pointer"
            @click="clearDropdown"
          >
            {{ $t('wording.clear') }}
          </div>
        </div>
      </div>
      <div v-else-if="dropdown && !multiSelect" class="relative">
        <div class="absolute bg-white rounded-2xl py-4 z-40 w-full shadow-xl">
          <div
            class="flex items-center mb-6 px-4"
            v-for="(data, key) of options"
            :key="key"
          >
            <img
              v-if="dataState === key"
              src="@/assets/svg/radio_on.svg"
              alt=""
              class="mr-2"
            />
            <img
              v-else
              src="@/assets/svg/radio_off.svg"
              alt=""
              class="mr-2"
              @click="() => (dataState = key)"
            />
            <p
              class="text-grey-2 text-sm text-opacity-50"
              :class="
                bold && dataState == key ? 'font-bold text-opacity-100' : ''
              "
            >
              {{ data }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- DAY -->
    <div v-else-if="type === 'day'">
      <div @click="() => (showDayModal = true)">
        <Field
          v-model="dataState"
          :rules="rules"
          :name="name" v-slot="{ field }">
          <input
            v-bind="field"
            autocomplete="off"
            class="card__card-input bg-white"
            :class="{ 'card__card-input--disabled': locked}"
            ref="field"
            :name="name"
            :rules="required ? isRequired : ''"
            :disabled="locked"
            :value="inputValue"
          />
        </Field>
      </div>
      <transition name="page">
        <div
        class="
          z-40
          bg-grey-2 bg-opacity-50
          h-screen
          w-full
          fixed
          top-0
          left-0
          lg:relative lg:h-auto lg:bg-opacity-0
        "
        v-if="showDayModal"
      >
        <div
          class="
            flex flex-col
            w-full
            h-screen
            lg:h-auto
            justify-end
            p-2
            lg:px-0
          "
        >
          <div class="bg-white rounded-2xl w-full p-4 pt-6 pb-16 lg:pb-4">
            <div class="flex items-center justify-between">
              <p class="text-left text-grey-2 text-opacity-80 font-semibold">
                {{ modalTitle }}
              </p>
              <img
                src="@/assets/svg/grey_cross.svg"
                alt="cross"
                @click="() => (showDayModal = false)"
                class="cursor-pointer hover:scale-105 transition-all"
              />
            </div>
            <p class="text-left text-grey-2 text-opacity-60 text-xs mt-4 mb-9">
              {{ modalText }}
            </p>
            <div
              class="flex justify-around my-4"
              :key="value"
              v-for="value in [1, 8, 15, 22, 29]"
            >
              <div
                class="
                  flex
                  justify-center
                  items-center
                  w-9
                  h-9
                  p-4
                  text-sm
                  rounded-xl
                "
                :class="selectedDay === value + day - 1 ? 'bg-orange-3' : ''"
                v-for="day in 7"
                :key="day"
              >
                <div
                  class="cursor-pointer text-grey-2 text-sm text-opacity-60"
                  :class="
                    selectedDay === value + day - 1
                      ? 'font-bold text-opacity-100'
                      : ''
                  "
                  v-if="value + day - 1 <= 30"
                  @click="
                    () => {
                      selectedDay = value + day - 1
                      dataState = '' + selectedDay
                      inputValue = `Day ${selectedDay} of every month`
                    }
                  "
                >
                  {{
                    // eslint-disable-next-line vue/no-parsing-error
                    value + day - 1 < 10
                      ? '0' + (value + day - 1)
                      : value + day - 1
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </transition>
    </div>
    <!-- DATE -->
    <div v-else-if="type === 'date'">

    <DatePicker
      v-model="dataState"
      mode="date"
      color="orange"
      ref="calendar"
      timezone="UTC"
      :max-date="to ? new Date(to) : to"
      :min-date="from ? new Date(from) : from"
      :popover="locked ? { visibility: false } : { visibility: 'click' }"
      :locale="locale"
      is-required
      :masks="{
        input: 'DD/MM/YYYY'
      }"
      :disabled="locked"
      @popoverWillShow="datePopup = true"
      @popoverWillHide="datePopup = false"
      :class="{ 'z-0': !datePopup }"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="card__card-input"
          :class="(locked ? 'card__card-input--disabled ' : ' ')"
          :value="inputValue"
          v-on="inputEvents"
          v-maska="'##/##/####'"
          @focus="showDatePlaceholder = false"
          @blur="dataState ? '' : (showDatePlaceholder = true)"
          :rules="rules"
          :disabled="locked"
        />
      </template>
    </DatePicker>
    </div>
    <!-- BIRTHDATE -->
    <Field
      v-else-if="type === 'birthdate'"
      class="card__card-input"
      :class="
        (locked ? 'card__card-input--disabled ' : ' ') +
        inputClasses +
        ' ' +
        bgColor
      "
      ref="field"
      v-model="dataState"
      :type="typeDup ?? type"
      :name="name"
      :rules="rules ? rules + '|birthdate' : 'birthdate'"
      :disabled="locked"
      v-maska="'## / ## / ####'"
      @keydown="validateInput"
      :noFocus="noFocus"
      @focus="setBirthdatePlaceholder"
      :autocomplete="'off'"
      novalidate
    />
    <div v-else-if="type === 'textarea'">
      <Field
        as="textarea"
        class="card__card-input card__card-input--textarea shadow-md h-56"
        :class="
          (locked ? 'card__card-input--disabled ' : ' ') +
          inputClasses +
          ' ' +
          bgColor
        "
        ref="field"
        v-model="dataState"
        :name="name"
        :rules="rules"
        :disabled="locked"
        :autocomplete="'off'"
        :min="min"
        :max="max"
        rows="4"
        :minLength="minLength"
        :maxLength="maxLength"
        :placeholder="placeholder"
        novalidate
      />
      <div
        class="
          text-grey-giftcard-title
          ml-auto
          text-xs
          absolute
          right-0
          -bottom-6
        "
      >
        {{ dataState ? dataState.length : 0 }} / {{ maxLength }}
      </div>
    </div>
    <div v-else-if="type === 'click-options'">
      <div class="steps__investor mb-6" @click="next(option.key)" v-for="(option) in options" v-bind:key="option">
        <div class="flex items-center">
          <div class="steps__investor__icon hidden md:block bg-gradient-green">
            <img :src="option.icon" alt="" />
          </div>
          <div>
            <div class="opacity-50 text-11 block md:hidden text-grey-2">
              {{ option.title_mobile }}
            </div>
            <div class="font-bold md:mb-0 mb-4 text-grey-2 opacity-80">
              {{ option.title }}
            </div>
            <div class="text-sm md:text-13 md:opacity-50 hidden md:block">
              {{ option.description }}
            </div>
          </div>
        </div>
        <div class="hidden md:block">
          <img src="@/assets/svg/chev-right-2.svg" alt="" />
        </div>
      </div>
    </div>
    <!-- OTHER -->
    <Field
      v-else
      class="card__card-input"
      :class="[
        locked ? (!label ? 'card__card-input--disabled-nolabel' : 'card__card-input--disabled') : '',
        inputClasses +
        ' ' +
        bgColor,
        type === 'dollar' ? 'card__card-input--dollar' : ''
      ]"
      ref="field"
      v-model="dataState"
      :type="typeDup ?? type"
      :id="name"
      :name="name"
      :min="min"
      :max="max"
      :minLength="minLength"
      :maxLength="maxLength"
      :exactLength="exactLength"
      :pattern="pattern"
      :rules="rules"
      :disabled="locked"
      :inputmode="type === 'dollar' ? 'decimal' : null"
      :aria-invalid="(error || manualError) ? 'true' : null"
      :aria-describedby="(error || manualError) ? name + '-error' : null"
      @keydown="validateInput"
      @blur="type === 'dollar' ? formatInput(true) : ''"
      @paste="type === 'dollar' ? handleDollarPaste($event) : ''"
      :noFocus="noFocus"
      :autocomplete="autocomplete"
      @input="autocomplete == 'off' ? (type === 'dollar' ? formatInput(false, $event) : '') : onInput()"
      @keypress="
        zipCode
          ? maskZip($event)
          : noNumbersOrSymbols
          ? isNumber($event) && isSymbol($event)
          : addressSymbols
          ? isAddress($event)
          : ''
      "
      novalidate
    />

    <div class="absolute right-7 bottom-5">
      <img
        v-if="locked && type !== 'radio'"
        src="@/assets/svg/padlock.svg"
        alt="padlock"
      />
    </div>
    <div
      class="
        absolute
        text-sm
        md:text-base
        top-7
        left-6
        md:top-7 md:left-6
        pointer-events-none
        opacity-50
      "
      v-if="type === 'date' && showDatePlaceholder && !dataState"
    >
      dd/mm/yyyy
    </div>
    <div
      class="
        absolute
        text-xs
        font-bold
        md:text-base
        top-6
        right-4
        md:top-6 md:right-6
        pointer-events-none
        opacity-20
      "
      v-if="optional"
    >
      {{ $t('wording.optional') }}
    </div>
    <div
      v-if="type === 'dollar' && dataState && !locked"
      class="
        card__card-input-dollar-icon
        text-sm md:text-base
        pointer-events-none
        opacity-50
      "
    >
      $
    </div>
    <label
      v-if="type !== 'checkbox' && type !== 'dropdown'"
      :for="name"
      class="card__card-input__label"
      :class="{
        'card__card-input__label--phone z-40': type === 'phone'
      }"
      >{{ label }}</label
    >
    <transition name="fade">
      <div
        class="absolute right-8 top-7 cursor-pointer"
        v-if="type === 'password' && dataState !== ''"
      >
        <div @click="switchVisibility">
          <img
            src="@/assets/ico/eye.svg"
            alt="password eye"
            v-if="typeDup === 'password'"
          />
          <img
            class="relative -top-0.5"
            src="@/assets/ico/eye-slash.svg"
            alt="password eye slash"
            v-else
          />
        </div>
      </div>
    </transition>
    <div
      v-if="error || manualError"
      :id="name + '-error'"
      class="card__card-input__error"
      :style="type === 'phone' ? 'position: absolute; left: 0; bottom: -20px; margin-left: 144px !important' : ''"
    >
      {{ error ?? manualError }}
    </div>
    <div class="text-left text-grey-3 text-xs mt-4" v-if="signupPassword">
      <div class="transition mb-1 flex" :class="{ 'text-grey-2': has8Chars }">
        <span class="font-bold mr-4" v-if="!has8Chars">&#x2022;</span>
        <img src="@/assets/svg/check_circle.svg" alt="" class="mr-2" v-else />
        <span>{{ $t('errors.has_8_chars') }}</span>
      </div>
      <div
        class="transition mb-1 flex"
        :class="{ 'text-grey-2': hasUpperLower }"
      >
        <span class="font-bold mr-4" v-if="!hasUpperLower">&#x2022;</span>
        <img src="@/assets/svg/check_circle.svg" alt="" class="mr-2" v-else />
        <span>{{ $t('errors.has_upper_lower') }}</span>
      </div>
      <div class="transition flex" :class="{ 'text-grey-2': hasNumberSymbol }">
        <span class="font-bold mr-4" v-if="!hasNumberSymbol">&#x2022;</span>
        <img src="@/assets/svg/check_circle.svg" alt="" class="mr-2" v-else />
        <span>{{ $t('errors.has_number_symbol') }}</span>
      </div>
    </div>
    <div v-show="autocomplete != 'off'">
      <div
        class="bg-white rounded py-4 z-60 w-full shadow-xl cursor-pointer flex items-center px-4"
        v-for="(suggestion, index) in suggestions" 
        @click="selectSuggestion(suggestion)"
        :key="index"  
      >
        <img
          v-if="dataState === key"
          src="@/assets/svg/radio_on.svg"
          alt=""
          class="mr-2"
        />
        <img
          v-else
          src="@/assets/svg/radio_off.svg"
          alt=""
          class="mr-2"
          @click="selectSuggestion(suggestion)"
        />
        <p
          class="text-grey-2 text-sm text-opacity-50"
          :class="
            bold && dataState == key ? 'font-bold text-opacity-100' : ''
          "
        >
          {{ suggestion.place_name }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref, onMounted, watch, inject } from 'vue'
import { Field } from 'vee-validate'
import useRules from '@/assets/js/rules'
import useCountries from '@/assets/js/countries'
import useCountriesCell from '@/assets/js/countries_cell'
import { DatePicker } from 'v-calendar'
import Multiselect from '@vueform/multiselect'
import { pt } from 'date-fns/locale'
import { subYears } from 'date-fns'
import { useVModel } from 'vue-composable'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

export default {
  emits: ['update:data', 'update:phoneCode', 'blured', 'next', 'change'],
  components: {
    Field,
    Multiselect,
    DatePicker
  },
  props: {
    triedToSubmit: {
      type: Boolean,
      default: false
    },
    noFocus: {
      type: Boolean,
      default: false
    },
    restrictCountries: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    greenBg: {
      type: Boolean,
      default: false
    },
    radioGreenBg: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    signupPassword: {
      type: Boolean,
      default: false
    },
    zipCode: {
      type: Boolean,
      default: false
    },
    country: String,
    searchable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    noNumbersOrSymbols: {
      type: Boolean,
      default: false
    },
    addressSymbols: {
      type: Boolean,
      default: false
    },
    options: [Array, Object],
    optional: {
      type: Boolean,
      default: false
    },
    optionsLabels: {
      type: Object,
      default: () => {}
    },
    toDate: [Date, Boolean],
    fromDate: [Date, Boolean],
    inputClasses: String,
    bgColor: {
      type: String,
      default: 'bg-white'
    },
    images: {
      type: String,
      default: null
    },
    styleBgColor: {
      type: String,
      default: 'white'
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    forceTop: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    caret: {
      type: Boolean,
      default: false
    },
    separatedRadio: {
      type: Boolean,
      default: false
    },
    noLines: {
      type: Boolean,
      default: false
    },
    noBoxes: {
      type: Boolean,
      default: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    grided: {
      type: Boolean,
      default: false
    },
    rules: String,
    name: String,
    label: String,
    error: String,
    multiselectLabel: String,
    multiselectTrackBy: String,
    multiselectValueProp: String,
    min: [String, Number],
    pattern: String,
    max: [String, Number],
    minLength: String,
    maxLength: [String, Number],
    exactLength: String,
    gtag: {
      type: String,
      default: 'input_changed',
    },
    phoneCode: String,
    periodicity: String,
    modalTitle: String,
    modalText: String,
    data: [String, Date, Boolean, Object, Number],
    suffix: String,
    showDaySelectorModal: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    let field = ref(null)
    const parentForm = inject("form")
    const datePopup = ref(false)
    const dataState = useVModel(props, 'data')
    const phoneCodeState = useVModel(props, 'phoneCode')
    let selectSearching = ref(false)
    let dataState_code = ref('+1')
    const store = useStore()
    const calendar = ref(null)
    const i18n = useI18n({ useScope: 'global' })
    const phoneCodeRef = ref(null)
    const { locale } = useI18n({ useScope: 'global' })
    const dropdown = ref(false)
    const manualError = ref(null)
    const rejectedInput = ref(false)
    let rejectedInputTimeout = null
    // const blockedCountries = computed(() => {
    //   return store.state.general.blockedCountries
    // })
    const goalHover = ref(null)
    const goals = ref([
      '1_no_poverty',
      '2_zero_hunger',
      '3_good_health_and_well-being',
      '4_quality_education',
      '5_gender_equality',
      '6_clean_water_and_sanitation',
      '7_affordable_and_clean_energy',
      '8_decent_work_and_economic_growth',
      '9_industry_innovation_and_infrastructure',
      '10_reduced_inequalities',
      '11_sustainable_cities_and_communities',
      '12_responsible_consumption_and_production',
      '13_climate_action',
      '14_life_below_water',
      '15_life_on_land',
      '16_peace_and_justice_strong_institutions',
      '17_partnerships_to_achieve_the_goal'
    ])

    const suggestions = ref([])

    const onInput = async () => {
      if (dataState.value.length > 2 && process.env.VUE_APP_MAPBOX === 'on') {
        const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(dataState.value)}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}&country=ca`)
        const data = await response.json()
        suggestions.value = data.features
      } else {
        suggestions.value = []
      }
    }

    const selectSuggestion = (suggestion) => {
      dataState.value = suggestion.place_name.slice(0,suggestion.place_name.indexOf(','))
      const data = suggestion.context.map(({ id, text }) => ({
        id: id.split('.')[0],
        text
      }))
      emit('autocomplete-selected', {
        contextData: data
      })
      suggestions.value = []
    }

    const to = computed(() => {
      return props.toDate !== null ? props.toDate : subYears(new Date(), 18)
    })
    let showDatePlaceholder = ref(true)
    const from = computed(() => {
      return props.fromDate !== null
        ? props.fromDate
        : subYears(new Date(), 120)
    })
    const { isRequired } = useRules()
    const { getCountries } = useCountries()
    const { getCountriesCell } = useCountriesCell()
    const typeDup = ref(null)
    const innerWidth = ref(null)

    const isMobile = computed(() => {
			return innerWidth.value < 1024
		})

    const showDayModal = computed({
      get(){
        return props.showDaySelectorModal
      },
      set(val){
        emit('showBottomSheet')
      }
      
    })
    const selectedDay = ref(null)
    const inputValue = ref('')

    const validField = computed(() => {
      let valid = false

      if (props.required) {
        valid = isRequired(dataState.value)
      }
      if (props.signupPassword) {
        valid = has8Chars.value && hasUpperLower.value && hasNumberSymbol.value
      }
      if (props.restrictCountries) {
        valid = dataState.value && !countryRestricted(dataState.value)
      }

      return valid
    })

    const next = (value) =>{
      emit('next', value)
    }

    watch(
      () => props.data,
      (first) => {
        if (props.type === 'date') {
          showDatePlaceholder.value = first ? false : true
          if(props.data){
            inputValue.value = props.data.toLocaleDateString('en-GB')
          }
        }
        if(props.type === 'day'){
            dataState.value = props.data
            selectDay()
        }
        if (
          props.type === 'date' ||
          props.type === 'multiselect' ||
          props.type === 'countries'
        ) {
          if (props.required && !props.data) {
            manualError.value = i18n.t('errors.required')
          } else {
            // if (props.type === 'countries' && props.restrictCountries) {
            //   if (countryRestricted(props.data)) {
            //     manualError.value = i18n.t('errors.banned_country')
            //   } else manualError.value = null
            manualError.value = null
          }
        }
      }
    )

    // function countryRestricted(country) {
    //   return blockedCountries.value.includes(country)
    // }

    function onGoalClick(key){
      const index = dataState.value.indexOf(key);
      if (index !== -1) {
        dataState.value.splice(index, 1); // Remove the key if it exists
      } else {
        if (dataState.value.length === 3) { // Already have 3 selected do nothing and return
          return;
        } else {
          dataState.value.push(key); // Add the key if it doesn't exist
        }
      }
    }

    function blured(evt) {
      emit('blured', evt)
    }

    function isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        return true
      } else {
        evt.preventDefault()
      }
    }

    function isSymbol(evt) {
      evt = evt ? evt : window.event
      if (
        !/(?=.*[!\\"#$%&/()=?\\_\\-\\@\\^\\+\\'\\»\\«\\,\\.\\>\\<\\£\\§\\$])/.test(
          evt.key
        )
      ) {
        return true
      } else {
        evt.preventDefault()
      }
    }

    function isAddress(evt) {
      evt = evt ? evt : window.event
      if (
        !/(?=.*[!\\"#$%&()=?\\_\\@\\^\\+\\'\\»\\«\\.\\>\\<\\£\\§\\$])/.test(
          evt.key
        )
      ) {
        return true
      } else {
        evt.preventDefault()
      }
    }

    function radioButtonPressed(val) {
      emit('radioPressed', val)
    }

    function maskZip(event) {
      if (props.zipCode) {
        if (props.country === 'PT') {
          if (event.key && !event.key.match(/[\d]/)) {
            event.preventDefault()
          } else {
            if (dataState.value.length >= 4 && event.key !== '-') {
              dataState.value =
                dataState.value.substr(0, 4) + '-' + dataState.value.substr(5) // in case people type "-"
            }
          }
        } else {
          if (event.key && !event.key.match(/[\da-zA-Z-]/)) {
            event.preventDefault()
          }
        }
      }
    }

    function isCharNumber(char) {
      if (typeof char !== 'string') {
        return false
      }

      if (char.trim() === '') {
        return false
      }

      return !isNaN(char)
    }

    function setBirthdatePlaceholder(e) {
      let missing = 'DD / MM / YYYY'.substring(dataState.value.length)
      let currentLen = dataState.value.length
      dataState.value = dataState.value + missing
      setTimeout(function () {
        e.target.setSelectionRange(currentLen, currentLen)
      }, 0)
    }

    function triggerRejectedInput() {
      clearTimeout(rejectedInputTimeout)
      rejectedInput.value = false
      // force a reflow so a rapid second rejection re-triggers the CSS animation
      requestAnimationFrame(() => {
        rejectedInput.value = true
        rejectedInputTimeout = setTimeout(() => {
          rejectedInput.value = false
        }, 300)
      })
    }

    function handleDollarPaste(evt) {
      evt.preventDefault()
      const clipboardData = evt.clipboardData || window.clipboardData
      const pasted = clipboardData ? clipboardData.getData('text') : ''

      let clean = pasted.replace(/[^\d.]/g, '')
      const dotIndex = clean.indexOf('.')
      if (dotIndex > -1) {
        clean = clean.slice(0, dotIndex + 1) + clean.slice(dotIndex + 1).replace(/\./g, '')
        const [intPart, decPart] = clean.split('.')
        clean = intPart + '.' + decPart.slice(0, 2)
      }

      if (!clean) {
        triggerRejectedInput()
        return
      }

      const target = evt.target
      const currentRaw = dataState.value ? dataState.value.toString().replace(/,/g, '') : ''
      const start = target?.selectionStart ?? currentRaw.length
      const end = target?.selectionEnd ?? currentRaw.length
      let merged = currentRaw.slice(0, start) + clean + currentRaw.slice(end)

      const mergedDot = merged.indexOf('.')
      if (mergedDot > -1) {
        merged = merged.slice(0, mergedDot + 1) + merged.slice(mergedDot + 1).replace(/\./g, '')
        const [mergedInt, mergedDec] = merged.split('.')
        merged = mergedInt + '.' + mergedDec.slice(0, 2)
      }

      dataState.value = merged
      formatInput(false, null, merged)
    }

    // `dataState` is a computed proxy over the `data` prop (see useVModel):
    // its setter only *emits* update:data, it never locally caches the new
    // value, so a read right after a write in the same tick still returns
    // the OLD prop value (props only update once the parent re-renders,
    // which is async). So this must never treat `dataState.value` as "the
    // current text mid-keystroke" - the DOM's own value (or an explicitly
    // just-computed value) is the only thing guaranteed to be current.
    function formatInput(blur, event, explicitValue) {
      const source = explicitValue ?? (event?.target ? event.target.value : dataState.value)
      if (source === '') {
        dataState.value = ''
        return
      }
      if (source) {
        let auxValue = source.toString()
        auxValue = auxValue.replace(/\,/g, '')
        auxValue = auxValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        // Computed on the final, comma-formatted string: the decimal-padding
        // math below counts characters after this position, so it must match
        // where the '.' actually ends up, not where it was pre-formatting.
        let indx = auxValue.indexOf('.')
        if (indx > -1 && blur) {
          let len = auxValue.length - indx - 1
          if (len < 2) {
            for (let i = len; i < 2; i++) {
              auxValue = auxValue + '0'
            }
          }
        }
        if (indx === -1 && blur) auxValue = auxValue + '.00'
        if (event?.target) {
          const cursorFromEnd = event.target.value.length - (event.target.selectionStart ?? event.target.value.length)
          event.target.value = auxValue
          const newPos = Math.max(0, auxValue.length - cursorFromEnd)
          event.target.setSelectionRange(newPos, newPos)
        }
        dataState.value = auxValue
      }
    }

    function validateInput(evt) {
      if (props.type === 'dollar') {
        // Navigation/editing keys (arrows, Home/End, Delete, Backspace, Tab,
        // Enter, Shift, ...) and any Ctrl/Cmd shortcut (copy/paste/select-all)
        // don't insert a character - none of the character/decimal-limit
        // validation below applies to them, so let the browser handle them.
        if (evt.key.length > 1 || evt.ctrlKey || evt.metaKey) {
          return
        }
        if (!isCharNumber(evt.key) && evt.key !== '.' && evt.key !== ',') {
          evt.preventDefault()
          triggerRejectedInput()
          return
        }
        // Read straight from the DOM, not `dataState.value` - see the note
        // on formatInput(): mid-keystroke, the prop-backed value can be stale.
        const currentValue = evt.target ? evt.target.value : dataState.value
        if (currentValue) {
          let auxValue = currentValue.toString()
          let indx = auxValue.indexOf('.')
          if (evt.key === '.' || evt.key === ',') {
            evt.preventDefault()
            if (indx === -1) {
              // Native insertion is prevented for this key, so insert the
              // decimal point ourselves at the actual cursor position
              // (not just appended to the end) and sync DOM + cursor.
              const start = evt.target?.selectionStart ?? auxValue.length
              const end = evt.target?.selectionEnd ?? auxValue.length
              auxValue = auxValue.slice(0, start) + '.' + auxValue.slice(end)
              dataState.value = auxValue
              if (evt.target) {
                evt.target.value = auxValue
                evt.target.setSelectionRange(start + 1, start + 1)
              }
            } else {
              triggerRejectedInput()
            }
          } else if (
            indx > -1 &&
            evt.target &&
            evt.target.selectionStart > indx &&
            evt.target.selectionStart === evt.target.selectionEnd &&
            auxValue.length - indx - 1 >= 2
          ) {
            evt.preventDefault()
            triggerRejectedInput()
          }
        }
      }
    }

    // const validEmail = computed(() => {
    //   return /[\w-.]+@([\w-]+\.)+[\w-]{2,4}/.test(dataState.value)
    // })

    const has8Chars = computed(() => {
      return dataState.value.length > 7
    })

    const hasUpperLower = computed(() => {
      return /(?=.*[a-z])(?=.*[A-Z])/.test(dataState.value)
    })

    const hasNumberSymbol = computed(() => {
      return /(?=.*\d)(?=.*[!\\"#$%&/()=?\\_\\-\\@\\^\\+\\'\\»\\«\\,\\.\\>\\<\\£\\§\\$\\`\\´\\~\\*])/.test(
        dataState.value
      )
    })

    function maskPhoneCode(val) {
      const el = val[val.length - 1]
      if (!parseInt(el) && el !== '-') {
        phoneCodeRef.value.search = phoneCodeRef.value.search.slice(0, -1)
      }
    }

    function getSdgSrc(goalHover, goal) {
      let lang = locale.value
      let numberPart = goal.split('_')[0]
      let index = numberPart < 10 ? '0' + numberPart : numberPart

      if (
        (dataState.value && dataState.value.includes(goal)) ||
        (!isMobile.value && goalHover === goal && dataState.value && dataState.value.length < 3)
      ) {
        return require(`@/assets/svg/goals/${lang}/SDG-${index}-${lang.toUpperCase()}.png`)
      } else {
        return require(`@/assets/svg/goals/${lang}/SDG-${index}-${lang.toUpperCase()}-INVERTED.png`)
      }
    }

    const today = computed(() => {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1 //January is 0!
      var yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }

      today = yyyy + '-' + mm + '-' + dd
      return today
    })

    onMounted(() => {
      if (process.browser) {
				innerWidth.value = window.innerWidth
				window.addEventListener('resize', () => { innerWidth.value = window.innerWidth })
			}
      if (props.type === 'password') {
        typeDup.value = props.type
      }
      // if (props.type === 'countries') {
      //   store.dispatch('setBlockedCountries')
      // }
      if (props.type === 'checkbox-group') {
        dataState.value = {}
      }
      if(props.type === 'sdgs'){
        dataState.value = []
      }

    })

    function changeSelect(value, field_name = null) {
      if (field_name && parentForm) {
        parentForm.value.validateField(field_name)
      }
      selectSearching.value = value
    }

    function switchVisibility() {
      typeDup.value = typeDup.value === 'password' ? 'text' : 'password'
    }

    function selectDay() {
      inputValue.value = `Day ${dataState.value} of every month`
    }

    const clearDropdown = () => {
      for (let d in dataState.value) {
        dataState.value[d] = false
      }
    }

    function toggleDataState(dataState, key) {
      if (!dataState['none'] || key === 'none') dataState[key] = !dataState[key]
      if (dataState['none'] && Object.keys(dataState).length > 1) {
        for (const option in dataState) {
          if (option !== 'none') {
            delete dataState[option];
          }
        }
      }
    }

    return {
      field,
      rejectedInput,
      handleDollarPaste,
      changeSelect,
      switchVisibility,
      hasUpperLower,
      hasNumberSymbol,
      selectSearching,
      has8Chars,
      showDatePlaceholder,
      suggestions,
      onInput,
      selectSuggestion,
      to,
      maskZip,
      pt,
      phoneCodeState,
      today,
      isRequired,
      getCountries,
      dataState,
      getCountriesCell,
      calendar,
      validField,
      dataState_code,
      datePopup,
      typeDup,
      showDayModal,
      selectedDay,
      inputValue,
      selectDay,
      validateInput,
      locale,
      formatInput,
      isNumber,
      phoneCodeRef,
      blured,
      setBirthdatePlaceholder,
      isSymbol,
      maskPhoneCode,
      isAddress,
      from,
      dropdown,
      manualError,
      isMobile,
      clearDropdown,
      next,
      //blockedCountries
      goals,
      goalHover,
      onGoalClick,
      getSdgSrc,
      parentForm,
      radioButtonPressed,
      toggleDataState
    }
  }
}
</script>

<style scoped>
.selected {
  text-shadow: 0 0 0.65px #4f5963, 0 0 0.65px #4f5963;
}
.multiselect-search {
  background: red;
}
.card__card-input--dollar {
  padding-left: 2.25rem !important;
  line-height: 1.25rem;
}
.card__card-input-dollar-icon {
  position: absolute;
  left: 1.25rem;
  top: 1.80rem;
}
.card__form-item--shake {
  animation: card__form-item-shake 0.3s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
@keyframes card__form-item-shake {
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-4px); }
  40%, 60% { transform: translateX(4px); }
}
@media (prefers-reduced-motion: reduce) {
  .card__form-item--shake {
    animation: none;
  }
}

</style>
